import SurveyFallback from "../images/fallbacks/survey.png";

export default {
  SURVEYS: { path: "/surveys", fallbackImg: SurveyFallback }
};
